function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
import SVG from "../../layouts/SVG.js";
export var HotelsIcon = function HotelsIcon(props) {
  var color = props.color;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 16V13.75C2.25 12.6454 3.14543 11.75 4.25 11.75H19.75C20.8546 11.75 21.75 12.6454 21.75 13.75V16M2.25 19.5V7.5C2.25 5.84315 3.59315 4.5 5.25 4.5H18.75C20.4069 4.5 21.75 5.84315 21.75 7.5V19.5M21.75 16.25H2.25M4.5 11.75V10.75C4.5 9.64543 5.39543 8.75 6.5 8.75H10C11.1046 8.75 12 9.64543 12 10.75M12 10.75V11.75M12 10.75C12 9.64543 12.8954 8.75 14 8.75H17.5C18.6046 8.75 19.5 9.64543 19.5 10.75V11.75",
    stroke: color || '#333333',
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};